// A subset of Utility Functions shared with Client Site

// works correctly on non-string data types as well
export function IsNullOrWhitespace(anything: any): boolean {
    // console.log(`typeof(anything) is '${typeof(anything)}'...`);
  
    if (anything == null ||                                            // note two equal signs, checks for null AND undefined   
       (typeof(anything) === 'string' && anything.trim() === "")) {       
      return true;
    }
    else {
      return false;
    } 
  }